import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ImageSelected from "../../components/management/imageselected";
//import Input from "./../management/input";
import {
  searchcustomer,
  saverequest,
  checkdo2,
  checkdo,
  getcustomertype,
  getProvince,
  getProductType,
  checkTosap,
  getmasterstore,
  getMasterdestination,
  getweighttail,confiremDo
} from "../../services/wms";

import {
  getTruckType,
  getaim,
  getProduct,
} from "./../../services/wms/grabconcept";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import Input from "./../management/input";
import Input from "../common/useform/input";
import Input1 from "./../common/inputfunction";
import { toast } from "react-toastify";
import BranchContext from "./../context/branch";
import Select2 from "./../wms/selectcustom1";
import ModalSearchprofilehub from "./../management/searchcustomerhub";
// import Input from "../wms/input";
import Inputdata from "../wms/inputdata";
import Select1 from "../../components/wms/select";
import dlv from "dlv";
import { split, stubString } from "lodash";
//d:/Project2022/WebWMSReact/react-wms/src/components/wms/select
const schema = yup.object({
  newdelivery: yup.string(),
  customertype: yup.string(),
  firstruck: yup.string(),
  secondtruck: yup.string(),
});

const Modaleditdo = ({ isOpen, onCancel, onConfirm, list, status }) => {
  const [custypeid, setcustypeid] = useState();
  const [custerdata, setcusterdata] = useState([]);
  const { currentBranch } = useContext(BranchContext);
  const [OpenModalSearch, setOpenModalSearch] = useState(false);
  const [custName, setcusName] = useState(); //editcustname
  const [customerType, setcustomerType] = useState([]);
  const [customerid, setcustomerid] = useState(0);
  const [firstProvince, setfirstProvince] = useState([]);
  const [truckType, settruckType] = useState([]);
  const [aimId, setaimId] = useState([]);
  const [aimNo, setaimNo] = useState([]);
  const [productType, setproductType] = useState([]);
  const [productTypeid, setproductTypeid] = useState("");
  const [product, setproduct] = useState([]);
  const [productid, setproductid] = useState(0);
  const [warningmessage, setwarningmessage] = useState("");
  const [error, seterror] = useState({});
  const [masterstore, setmasterstore] = useState([]);
  const [masterdestination, setmasterdestination] = useState([]);
  const [weighttail, setweighttail] = useState([]);

  const [storeID, setstoreId] = useState(0);
  const [desID, setdesID] = useState(0);
  const [comment, setcomment] = useState("");
  const [namelist, setnamelist] = useState("");
  const [queueid, setqueueid] = useState(0);

  const [tailid, settailid] = useState(0);
  const [colorin, setcolorin] = useState("");
  const [colorout, setcolorout] = useState("");
  const [colorcancle, setcolorcancle] = useState("");

  const [onsave, setonsave] = useState(false);
  const [total, settotal] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });
  const [checkdo, setcheckdo] = useState();
  const [formdata, setformdata] = useState({});
  const [id, setid] = useState(2);
  const [formData, setformData] = useState({});

  const [formLoad, setformLoad] = useState(false);
  const [newData, setnewData] = useState({});
  useEffect(() => {
    settotal(0)
    setcomment("")
  }, [list]);
  useEffect(() => {
    // if (!isOpen) return
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === undefined) return;
    // if (!formLoad)return;
    if (list && list.length > 0) {
      reset({
        firstruck: list[0].First_driven_no,
        fprovince: list[0].Firstdrivenprov,
        fsecondtruck: list[0].Second_driven_no,
        sprovince: list[0].Seconddrivenprov,
        truckType: list[0].truckrtypeID,
         newdelivery: list[0].Delivery_No,
        customertype: list[0].CustomerType_ID,
      });
      setcolorin("secondary")
      setcolorout("secondary")
      setcolorcancle("secondary")
      setnamelist("")
      setformLoad(false)
    }
  }, [list,isOpen,currentBranch,formLoad]);


  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getProductType(
        currentBranch && currentBranch._id
      );

      if (result.length > 0) {
        setproductType(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === undefined) return;
    if (!productTypeid) return;
    if (productTypeid === undefined) return;
    if (currentBranch._id === "000") return;
    //  if (!productTypeid) return;
    const loadData = async () => {
      const { data: result } = await getProduct(
        productTypeid,
        currentBranch && currentBranch._id
      );

      if (result.length > 0) {
        setproduct(result);
      }
    };
    loadData();
  }, [currentBranch, productTypeid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getProvince(
        currentBranch && currentBranch._id
      );


      if (result.length > 0) {
        setfirstProvince(result);
      }
    };
    loadData();
    // });
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getaim(505);
      if (result) {
        setaimNo(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getTruckType(
        currentBranch && currentBranch._id
      );
      if (result.length > 0) {
        settruckType(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getweighttail(
        currentBranch && currentBranch._id
      );
      if (result.data.length === 0){
        return;
      }
      if (result.status === "success") {
        setweighttail(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getmasterstore(
        currentBranch && currentBranch._id
      );
      if (result.status === "success") {
        setmasterstore(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "000") return;
    const loadData = async () => {
      const { data: result } = await getMasterdestination(
        currentBranch && currentBranch._id
      );
      if (result.status === "success") {
        setmasterdestination(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  const checksap = async (data) => {
    const { data: result } = await checkTosap(data);
    if (result.length > 0) {
      if (result[0].Status === "False") {
        return false;
      } else {
        return true;
      }

    }else {
      return false
    }
  };
  const confirmdo1 = async (doid,cusid) => {
    const { data: result } = await confiremDo(currentBranch._id,doid,cusid);
      if (result === false) {
        return false;
      } else {
        return true;
      }

    
  };
  useEffect(() => {
    if (list && list.length > 0) {
      setcustypeid(list[0].customertype);
      setcusName(list[0].Customer_name);
      setformdata({
        ...formdata,
        olddeliveryno: list[0].Delivery_No,
        Weight_No: list[0].Weight_No,
        Customertype_Name: list[0].CustomerType_name,
        Type_ID: list[0].Type_ID,
         customertype: list[0].CustomerType_ID,
        Aim_no: list[0].Aim_no,
        firstdrivenno: list[0].First_driven_no,
        firstdrivenprove: list[0].Firstdrivenprov,
        Seconddrivenno: list[0].Second_driven_no,
        Seconddrivenprov: list[0].Second_driven_prov,
        TruckType: list[0].truckrtypeID,
        productid: list[0].Product_ID,
        firstdrivenprovecode: list[0].First_driven_prov,
        Seconddrivenprovcode: list[0].Second_driven_prov,
        store: list[0].Store_name,
        destination: list[0].Dest_name,
      });
    
    }
  }, [list]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!isOpen) return;
    const loadData = async () => {
      const { data: result } = await getcustomertype("501");

      if (result.status === "success") {
        setcustomerType(result.data.list);
        
      }
    };
    loadData();
  }, [isOpen]);

  const handleInputChange = (inputKey, data, validate) => {
  
     const subList = {...formdata};
     setnewData({ ...newData, [inputKey]: data });
     setformdata({...formdata, [inputKey]: data })
    if (data) {
      seterror({ ...error, [inputKey]: "" });
    }
  };
  // const handleInputChange = (inputKey, data, validate) => {
  //   const subList = [...getscraptype];
  //   const subIndex = subList.findIndex((index) =>index._id === inputKey);
  //   subList[subIndex].amount = data
  //   setgetscraptype(subList)
  // };
  const onSubmit = async (data) => {
    let saveDoc;

    const ConfirmSap = await checksap(formdata.Weight_No);
    if (ConfirmSap) {
      toast.error("รายการนี้ถูกทำจ่ายแล้ว ค่ะ");
      return;
    }

if (formdata.Type_ID===2 && (formdata.customertype==="04" || formdata.customertype==="15") && (formdata.Aim_no==="01" ||formdata.Aim_no==="03" ) ){
  const Confirmdo = await confirmdo1(data.newdelivery,formdata.customertype);
  if (Confirmdo=== false) {
    toast.error("DO ไม่ถูกต้อง ค่ะ");
    return;
  }

 }

    if (!comment) {
      toast.error("กรุณาระบุเหตุผล ค่ะ");
      return;
    }

    if (parseInt(status) === 2) {
      // if (!data.newdelivery) {
      //   toast.error("ระบุ DO ค่ะ");

      //   return;
      // }
      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.olddeliveryno,
        newdata: data.newdelivery,
        comment: comment,
      };
    } else if (parseInt(status) === 3) {
      // if (!customerid || customerid =="0") {
      //   toast.error("ระบุ ชื่อลูกค้า ค่ะ")
      //    return
      //  }
      saveDoc = {
        branchid: currentBranch._id,
        code: status,
        weightno: formdata.Weight_No,
        olddata: {
          CustomerType: list[0].CustomerType_ID,
          Customer_name: list[0].Customer_name,
        },
        newdata: { CustomerType: data.customertype, customerid: customerid },
        comment: comment,
      };
    } else if (parseInt(status) === 4) {
      if (!data.firstruck || data.fprovince === "0") {
        toast.error("ระบุ ทะเบียนรถ  ค่ะ");
        return;
      }
      if (data.truckType == "T" || data.truckType == "P") {
        if (data.fsecondtruck == "" || data.sprovince === null) {
          toast.error("ระบุ ทะเบียนหางรถ  ค่ะ");
          return;
        }
      }

      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: {
          firstdrivenno:
            formdata.firstdrivenno +
            ":" +
            formdata.firstdrivenprovecode +
            ":" +
            formdata.TruckType,
          seconddrivenno:
            formdata.Seconddrivenno +
            ":" +
            formdata.Seconddrivenprovcode +
            "" +
            formdata.TruckType,
          Trucktype: formdata.TruckType,
        },
        newdata: {
          firstdrivenno:
            data.firstruck + ":" + data.fprovince + ":" + data.truckType,
          seconddrivenno:
            data.fsecondtruck + ":" + data.sprovince + ":" + data.truckType,
          Trucktype: data.truckType,
        },
        comment: comment,
      };
    } else if (parseInt(status) === 5) {
      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.Aim_no,
        newdata: aimId,
        comment: comment,
      };
    } else if (parseInt(status) === 6) {
 
      if (parseInt(productid) === 0) {
        toast.error("กรุณาเลือกสินค้า ค่ะ");
        return;
      }
      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.productid,
        newdata: productid,
        comment: comment,
      };
    } else if (parseInt(status) === 7) {
      if (storeID === 0) {
        toast.error("กรุณาเลือกที่ลงสินค้า ค่ะ");
        return;
      }

      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.store,
        newdata: storeID,
        comment: comment,
      };
    } else if (parseInt(status) === 8) {
      if (tailid === 0) {
        toast.error("กรุณาเลือกที่ลงสินค้า ค่ะ");
        return;
      }

      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: "",
        newdata: tailid,
        comment: comment,
      };
    } else if (parseInt(status) === 10) {
      if (desID === 0) {
        toast.error("กรุณาเลือกที่ส่งสินค้า ค่ะ");
        return;
      }

      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.destination,
        newdata: desID,
        comment: comment,
      };
    } else if (parseInt(status) === 8) {
      if (productid === 0) {
        toast.error("กรุณาเลือกสินค้า ค่ะ");
        return;
      }
      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: formdata.productid,
        newdata: productid,
        comment: comment,
      };
    } else if (parseInt(status) === 9) {
      if (queueid === 0) {
        toast.error("กรุณาเลือกรายการ ค่ะ");
        return;
      }
      saveDoc = {
        code: status,
        branchid: currentBranch._id,
        weightno: formdata.Weight_No,
        olddata: 0,
        newdata: queueid,
        comment: comment,
      };
    }
    if (status == 2) {
      // if (saveDoc.newdata == undefined || saveDoc.newdata == "") {
      //   toast.error("กรุณาใส่ DO ค่ะ");
      //   return
      // }

      if (
        (formdata.Customertype_Name =
          "ไม้สาขาหางลากน้ำหนัก" ||
          formdata.Customertype_Name == "ไม้ลานลูกค้า" ||
          formdata.Customertype_Name == "ไม้เก็บกลับKN") &&
        formdata.Type_ID == "2"
      ) {
        if (!currentBranch) return;

        const loadData = async () => {
          const { data: result } = await checkdo2(
            currentBranch && currentBranch._id,
            data.newdelivery
          );
          if (result.status == "success") {
            setcheckdo(result.data.list);
          }
        };
        loadData();
      } else if (formdata.Customertype_Name == "ไม้เหมาแปลงแบบตัน") {
        const loadData = async () => {
          const { data: result } = await checkdo(
            currentBranch && currentBranch._id,
            data.newdelivery
          );
          if (result.status == "success") {
            setcheckdo(result.data.list);
          }
        };
        loadData();
      }
    } else if (status == 4) {
      // if (saveDoc.newdata == undefined || saveDoc.newdata == "") {
      //   toast.error("กรุณาใส่ทะเบียนรถ ค่ะ");
      //   return;
      // }
    } else if (status == 5) {
      if (
        saveDoc.newdata == "0" ||
        saveDoc.newdata == "" ||
        saveDoc.newdata == undefined
      ) {
        toast.error("กรุณาเลือกวัตถุประสงค์");
        return;
      }
      if (saveDoc.olddata == saveDoc.newdata) {
        toast.error("วัตถุประสงค์ซ้ำ");
        return;
      }
    }

     doSubmit(saveDoc);
  };

  const doSubmit = async (doc) => {
    // console.log("doc",doc)
    setonsave(true);
    const { data: result } = await saverequest(doc);
    if (result.status === "success") {
      toast.success("บันทึกเสร็จเรียบร้อย");
      onConfirm();
      setonsave(false);
    } else {
      toast.error(result.message);
      setonsave(false);
    }
  };
  const handleCancleSubmit = () => {
    setOpenModalSearch(false);
  };
  const handlechangnamelist = (data) => {
    if (!data) return;
    if (data === 1) {
      setcolorin("primary")
      setcolorout("secondary")
      setcolorcancle("secondary")
      setnamelist("ยกเลิกชั่งเข้า");
    } else if (data === 2) {
      setcolorin("secondary")
      setcolorout("primary")
      setcolorcancle("secondary")
      setnamelist("ยกเลิกชั่งออก");
    } else if (data === 3) {
      setcolorin("secondary")
      setcolorout("secondary")
      setcolorcancle("primary")
      setnamelist("ยกเลิกคิวชั่ง");
    }
    setqueueid(data);
  };
  const handleConfirmSubmit = (event) => {
    setcusName(event.name);
    setOpenModalSearch(false);
 
    setcustomerid(event._id);
  };

  const handleChangweighttail = (event) => {
    settailid(event.currentTarget.value);
    // settotal({...weighttail})


    const sub = [...weighttail];
    //  const index = sub.filter((x) => x.id === event.currentTarget.value);
     const result = sub.filter((i) => i.id == event.currentTarget.value);
     settotal(result[0].weight)


    //     console.log("result=>", result[0]);
    //     const data = result[0];
    //     updateData(data);
 
  };

  const handleSearchCustomer = () => {
    // setformLoad(true)
    setOpenModalSearch(true);
  };
  const handlechangcomment = (e) => {
    setcomment(e.currentTarget.value);
  };

  const handleCancle = (e) => {
    setnamelist("");
    setqueueid(0);
    setcustomerid("0");
    onCancel(false);
  };

  const oncusnameKeyPress = (event) => {
    if (!custName) {
      return;
    }
    if (event.key === "Enter") {
      if (!OpenModalSearch) {
        setOpenModalSearch(true);
      }
    }
  };
  const handleChangecusTypeID = (event) => {
    setcustypeid(event.currentTarget.value);
  };
  const handleChangCusId = (event) => {
    setcusName(event.currentTarget.value);
  };
  const handleChangeAimNo = (event) => {
    setaimId(event.currentTarget.value);
  };
  const handleChangetypeId = (event) => {
    setproductid(0);
    setproductTypeid(event.currentTarget.value);
  };
  const handleChangeproduct = (event) => {
    setproductid(event.currentTarget.value);
  };
  const handleSelectChangestore = (data) => {
    if (!data) return;
    setstoreId(data.currentTarget.value);
    setdesID(0);
  };
  const handleSelectChangedes = (data) => {
    if (!data) return;
    setdesID(data.currentTarget.value);
    setstoreId(0);
  };
  return (
    <div>
      <ModalSearchprofilehub
        isOpen={OpenModalSearch}
        header={"ข้อมูลผู้ขาย/ลูกค้า"}
        search={custName}
        list={custerdata}
        onCancel={handleCancleSubmit}
        onSelect={handleConfirmSubmit}
      />
      <Modal
        className="modal-dialog modal-xl"
        isOpen={isOpen}
        toggle={onCancel}
        centered
      >
        <ModalHeader>
          {list && list.length > 0 && (
            <p className=" text-primary me-2  fs-2 fw-bold ">
              <i className="bi bi-box me-2" /> เลขที่ใบชั่ง :
              <span>{list[0].Weight_No}</span>
            </p>
          )}
        </ModalHeader>
        <ModalBody>
          <>
            {list &&
              list.length > 0 &&
              list.map((item, index) => (
                <div className="modal-body p-0" key={index}>
                  <div className="modal-body">
                    <div className="row" style={{ fontSize: 14 }}>
                      <div className=" col-lg-6">
                        <div>
                          <h6>
                            รหัสลูกค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Customer_Code}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ประเภทลูกค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.CustomerType_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ชื่อลูกค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Customer_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ประเภทสินค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Type_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ชื่อสินค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Product_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ประเภทรถ :
                            <small style={{ fontSize: 14 }}>
                              {item.TruckType}
                            </small>
                          </h6>
                        </div>
                        <div className="row">
                          <div className="col-auto">
                            <h6>
                              ทะเบียนรถ :
                              <small style={{ fontSize: 14 }}>
                                {item.First_driven_no} :{item.First_driven_prov}
                              </small>
                            </h6>
                          </div>
                          <div className="col-auto">
                            <h6>
                              ทะเบียนหาง :
                              <small style={{ fontSize: 14 }}>
                                {item.Second_driven_no}:
                                {item.Second_driven_prov}
                              </small>
                            </h6>
                          </div>
                        </div>

                        <div />
                      </div>
                      <div className=" col-lg-6">
                        <div>
                          <h6>
                            วัตถุประสงค์ :
                            <small style={{ fontSize: 14 }}>
                              {item.aim_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            DO :
                            <small style={{ fontSize: 14 }}>
                              {item.Delivery_No}
                            </small>
                          </h6>
                        </div>

                        <div>
                          <h6>
                            วันที่ทำรายการ : 22-05-2022
                            <small style={{ fontSize: 14 }}></small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักชั่งเข้า :
                            <span className="badge rounded-pill bg-success ms-2">
                              {item.Receive_weightin}
                            </span>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักชั่งออก :
                            <span className="badge rounded-pill bg-primary ms-2">
                              {item.Receive_weightout}
                            </span>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักสุทธิ :
                            <span className="badge rounded-pill bg-warning text-dark ms-2">
                              {item.Receive_weightnet}
                            </span>
                          </h6>
                        </div>

                        <div />
                      </div>
                      {parseInt(status) === 2 && (
                        <>
                          <div className="col-sm-6 col-xs-12 mt-4">
                            <span className="badge rounded-pill bg-primary fs-6 my-4 ">
                              <i className="bi bi-book-fill "></i>
                              <span className="m-2">
                                เลขที่ DO เก่า : {item.Delivery_No}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-6 col-xs-12 mt-4">
                          {/* <Inputdata
                  label="เลขที่ DO ใหม่"
                  name="newdelivery"
                  type="text"
                  placeholder=""
                  className="form-control"
                  value={newData.newdelivery}
                  onChange={handleInputChange}           
                  error={error.newdelivery}
                /> */}
                            <Input
                              icon="bi bi-book-fill text-danger me-2"
                              label="เลขที่ DO ใหม่"
                              name="newdelivery"
                              register={register}
                              required
                              errors={errors.newdelivery}
                            />
                          </div>
                        </>
                      )}
                      {parseInt(status) === 3 && (
                        <div className="row">
                          <div className="col-lg-6  mt-2">
                            <i className="bi bi-book-fill text-primary me-2"></i>
                            ประเภทลูกค้าเดิม :
                            <span
                              className="badge rounded bg-primary  ms-2 mt-4"
                              style={{ fontSize: 14 }}
                            >
                              {item.CustomerType_name}
                            </span>
                          </div>
                          <div className="col-lg-6 mt-2">
{/* 
                          <Select
                              list={aimNo}
                              value={aimId}
                              textProperty="customertype"
                              valueProperty="aim_no"
                              onChange={handleChangeAimNo}
                              errors={errors.ProvinceID}
                            /> */}
                            <Select
                              icon="bi bi-book-half  text-info me-2"
                              label="ประเภทลูกค้า"
                              name="customertype"
                              list={customerType}
                              {...register("customertype")}
                              required
                              errors={errors.customertype}
                            />
                          </div>
                          <div className="col-lg-6  mt-4">
                            <i className="bi bi-book-fill text-primary me-2"></i>
                            ชื่อลูกค้าเดิม :
                            <span
                              className="badge rounded bg-warning text-dark ms-2 "
                              style={{ fontSize: 14 }}
                            >
                              {item.Customer_name}
                            </span>
                          </div>
                          <div className="col-lg-6 mt-2">
                            <div className="row">
                              <Input1
                                label="ชื่อลูกค้าใหม่"
                                name="customername"
                                value={custName}
                                placeholder="กรอกชื่อลูกค้า"
                                onChange={handleChangCusId}
                                onKeyPress={oncusnameKeyPress}
                                onClick={handleSearchCustomer}
                                search="ค้นหา"
                                disable={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-12 mt-4">
                            <span className="badge text-dark fs-6 mt-2 ">
                              <i className="bi bi-book-fill text-primary"></i>
                              <span className="ms-2">
                                เลขที่ DO เก่า : {item.Delivery_No}
                              </span>
                            </span>
                          </div>
                          <div className="col-sm-6 col-xs-12 mt-4">
               
                            <Input
                              icon="bi bi-book-fill text-danger me-2"
                              label="เลขที่ DO ใหม่"
                              name="newdelivery"
                              register={register}
                              required
                              errors={errors.newdelivery}
                            />
                          </div>
                        </div>
                      )}
                      {parseInt(status) === 4 && (
                        <>
                          <div className="row mt-4">
                            <div className="col-lg-4">
                              <Select
                                icon="bi bi-book-half  text-info me-2"
                                label="ประเภทรถ"
                                textProperty="truck_typename"
                                valueProperty="truck_typeid"
                                name="truckType"
                                list={truckType}
                                {...register("truckType")}
                                required
                                errors={errors.truckType}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-4">
                              <Input
                                icon="bi bi-truck-flatbed text-primary me-2"
                                label="ทะเบียนหัว"
                                name="firstruck"
                                register={register}
                                required
                                errors={errors.firstruck}
                              />
                            </div>
                            <div className="col-lg-4">
                              <Select
                                icon="bi bi-book-half  text-info me-2"
                                label="จังหวัด"
                                textProperty="ProvinceName"
                                valueProperty="ProvinceID"
                                name="fprovince"
                                list={firstProvince}
                                {...register("fprovince")}
                                required
                                errors={errors.fprovince}
                              />
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-lg-4">
                              <Input
                                icon="bi bi-truck-flatbed text-primary me-2"
                                label="ทะเบียนหาง"
                                name="fsecondtruck"
                                register={register}
                                required
                                errors={errors.fsecondtruck}
                              />
                            </div>
                            <div className="col-lg-4">
                              <Select
                                icon="bi bi-book-half  text-info me-2"
                                label="จังหวัด"
                                textProperty="ProvinceName"
                                valueProperty="ProvinceID"
                                name="sprovince"
                                list={firstProvince}
                                {...register("sprovince")}
                                required
                                errors={errors.sprovince}
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {parseInt(status) === 5 && (
                        <div className="row mt-4">
                          <div className="col-lg-6 ">
                            <i className="bi bi-book-fill text-primary me-2"></i>
                            ข้อมูลวัตถุประสงค์เก่า :
                            <span
                              className="badge rounded bg-warning text-dark ms-2 "
                              style={{ fontSize: 14 }}
                            >
                              {item.aim_name}
                            </span>
                          </div>

                          <div className="col-sm-6 col-xs-12 ">
                            <Select
                              list={aimNo}
                              value={aimId}
                              textProperty="aim_name"
                              valueProperty="aim_no"
                              onChange={handleChangeAimNo}
                              errors={errors.ProvinceID}
                            />
                          </div>
                        </div>
                      )}
                      {parseInt(status) === 6 && (
                        <>
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12">
                              <i className="bi bi-book-fill text-primary me-2"></i>
                              ประเภทสินค้า :
                              <span
                                className="badge rounded bg-warning text-dark ms-2 "
                                style={{ fontSize: 14 }}
                              >
                                {item.Type_name}
                              </span>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-12 my-2 ">
                              <Select
                                list={productType}
                                value={productTypeid}
                                textProperty="type_name"
                                valueProperty="Type_ID"
                                onChange={handleChangetypeId}
                                //errors={errors.ProvinceID}
                              />
                            </div>
                          </div>
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12 my-2 ">
                              <i className="bi bi-book-fill text-primary me-2"></i>
                              ชื่อสินค้า :
                              <span
                                className="badge rounded bg-warning text-dark ms-2 "
                                style={{ fontSize: 14 }}
                              >
                                {item.Product_name}
                              </span>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-xs-12 ">
                              <Select
                                list={product}
                                value={productid}
                                textProperty="ProductName"
                                valueProperty="Product_ID"
                                onChange={handleChangeproduct}
                                //errors={errors.ProvinceID}
                              />
                            </div>
                          </div>
                        </>
                      )}
                     
                      {parseInt(status) === 7 &&
                     
                      (formdata.Aim_no === "02" || formdata.Aim_no === "04") ? (
                        <>
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12 my-2 ">
                              <i className="bi bi-book-fill text-primary me-2"></i>
                              สถานที่จัดส่งเดิม :
                              <span
                                className="badge rounded bg-warning text-dark ms-2 mt-3 "
                                style={{ fontSize: 14 }}
                              >
                                {item.Dest_name}
                              </span>
                            </div>

                            {/* <div className="col-lg-6 col-sm-6 col-xs-12 ">
                              <Select
                                name="destination"
                                label={"สถานที่จัดส่งใหม่"}
                                list={masterdestination}
                                textProperty="name"
                                valueProperty="id"
                                 //value={formData.time}
                                // disabled={disableSave || loading}
                                  onChange={handleSelectChangedes}
                                // error={messageError.time}
                               
                              />
                            </div> */}
                          </div>
                        </>
                      ) : (
                        parseInt(status) === 7 && (
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12 my-2 ">
                              <i className="bi bi-book-fill text-primary me-2"></i>
                              สถานที่จัดเก็บสินค้า :
                              <span
                                className="badge rounded bg-warning text-dark ms-2 mt-3 "
                                style={{ fontSize: 14 }}
                              >
                                {item.Store_name}
                              </span>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-xs-12 ">
                              <Select
                                label={"สถานที่จัดเก็บสินค้า"}
                                list={masterstore}
                                textProperty="name"
                                valueProperty="id"
                                // error={error.store}
                                value={formData.store}
                                // disabled={disableSave || loading}
                                onChange={handleSelectChangestore}
                                // error={messageError.time}
                                name={"store"}
                              />
                            </div>
                          </div>
                        )
                      )}
                      {parseInt(status) === 10 &&
                      (formdata.Aim_no === "02" || formdata.Aim_no === "04") ? (
                        <>
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12 my-2 ">
                              <i className="bi bi-book-fill text-primary me-2"></i>
                              สถานที่จัดส่งเดิม :
                              <span
                                className="badge rounded bg-warning text-dark ms-2 mt-3 "
                                style={{ fontSize: 14 }}
                              >
                                {item.Dest_name}
                              </span>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-xs-12 ">
                              <Select
                                name="destination"
                                label={"สถานที่จัดส่งใหม่"}
                                list={masterdestination}
                                textProperty="name"
                                valueProperty="id"
                                //value={formData.time}
                                // disabled={disableSave || loading}
                                onChange={handleSelectChangedes}
                                // error={messageError.time}
                              />
                            </div>
                          </div>
                        </>
                      ) : null}
                      {parseInt(status) === 8 && (
                        <>
                          <div className="row mt-4">
                            <div className="col-lg-6 col-sm-6 col-xs-12 ">
                              <Select
                                label={"เลือกทะเบียนหางสต๊อก"}
                                list={weighttail}
                                textProperty="name"
                                valueProperty="id"
                                // value={formData.time}
                                // disabled={disableSave || loading}
                                onChange={handleChangweighttail}
                                // error={messageError.time}
                                name={"tail"}
                              />
                            </div>

                            <div className="col-lg-6 col-xs-6 mt-3">
                              <span className="fs-6">น้ำหนักหางสต๊อก</span>
                              <span className="badge rounded-pill bg-success ms-3">
                                <span className="mx-3 fs-6">
                                {total}
                                  {/* {2000} */}
                                </span>
                              </span>
                            </div>
                            <div className="row  d-flex justify-content-center">
                              <div className="col-lg-6 col-xs-6 mt-2 ">
                                <ImageSelected />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {parseInt(status) === 9 && (
                        <>
                          <div className="row mt-4 d-flex justify-content-center">
                            {item.Receive_weightout == 0 && (
                              <div className="col-auto my-2">
                                <Button
                                  color={colorin}
                                  // onClick={handlechangnamelist(1)}
                                  onClick={() => handlechangnamelist(1)}
                                >
                                  <span className="mx-3 fs-4">
                                    ยกเลิกชั่งเข้า
                                  </span>
                                </Button>
                              </div>
                            )}

                            {item.Receive_weightout > 0 && (
                              <div className="col-auto my-2">
                                <Button
                                  color={colorout}
                                  onClick={() => handlechangnamelist(2)}
                                >
                                  <span className="mx-3 fs-4">
                                    ยกเลิกชั่งออก
                                  </span>
                                </Button>
                              </div>
                            )}

                            <div className="col-auto my-2">
                              <Button
                                color={colorcancle}
                                onClick={() => handlechangnamelist(3)}
                              >
                                <span className="mx-4 fs-4">ยกเลิกคิวชั่ง</span>
                              </Button>
                            </div>
                          </div>
                          <div className=" my-2 d-flex justify-content-center">
                            <div className="row card1 shadow">
                              <span className=" m-2 mx-4 fs-4">
                                รายการที่เลือก :<span className="text-danger m-2 mx-4 fs-4">
                               {namelist}
                              </span> 
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-lg-6 col-xs-6 mt-2 ">
                        <Input1
                          name="comment"
                          value={comment}
                          placeholder="ระบุเหตุผล"
                          onChange={handlechangcomment}
                        />
                      </div>
                      {(parseInt(status) === 3 ||
                        parseInt(status) === 4 ||
                        parseInt(status) === 6) && (
                        <div className="col-lg-6 col-xs-6 mt-2 ">
                          <ImageSelected />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </>
        </ModalBody>
        <ModalFooter>
          <div className="col-auto">
            <div className="row">
              <div className=" col-auto ">
                <Button color="primary" disabled ={onsave} onClick={handleSubmit(onSubmit)}>
                  Confirm
                </Button>
              </div>
              <div className="col-auto ">
                <Button color="secondary" onClick={handleCancle}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modaleditdo;
